import { isPlatform } from '@ionic/angular/standalone';
import { arrowBack, chevronBack } from 'ionicons/icons';

export const backIcon = isPlatform('ios') ? chevronBack : arrowBack;
